import { useSelector } from 'react-redux';
import { TradingPartnerItem } from '../../redux/localReports/localReports.proptype';
import { selectSelectedTradingPartners } from '../../selectors';

export const useSelectedTradingPartners = (): TradingPartnerItem[] => {
  const selectedTradingPartners = useSelector(selectSelectedTradingPartners);

  return selectedTradingPartners;
};
